(function(){"use strict";try{if(typeof document<"u"){var t=document.createElement("style");t.appendChild(document.createTextNode('.drop-down-left-enter-from,.drop-down-left-leave-to{transform:scale3d(.95,.95,1) translateZ(0);opacity:0}.drop-down-left-enter-active,.drop-down-left-leave-active{backface-visibility:hidden;will-change:opacity,transform;contain:layout style paint}.drop-down-left-enter-active{transform-origin:top right;transition-property:opacity,transform;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.drop-down-left-leave-active{transform-origin:top right;transition-property:opacity,transform;transition-duration:75ms;transition-timing-function:cubic-bezier(.4,0,.2,1)}.drop-down-right-enter-from,.drop-down-right-leave-to{transform:scale3d(.95,.95,1) translateZ(0);opacity:0}.drop-down-right-enter-active,.drop-down-right-leave-active{backface-visibility:hidden;will-change:opacity,transform;contain:layout style paint}.drop-down-right-enter-active{transform-origin:top left;transition-property:opacity,transform;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.drop-down-right-leave-active{transform-origin:top left;transition-property:opacity,transform;transition-duration:75ms;transition-timing-function:cubic-bezier(.4,0,.2,1)}.drop-up-left-enter-from,.drop-up-left-leave-to{transform:scale3d(.95,.95,1) translateZ(0);opacity:0}.drop-up-left-enter-active,.drop-up-left-leave-active{backface-visibility:hidden;will-change:opacity,transform;contain:layout style paint}.drop-up-left-enter-active{transform-origin:bottom right;transition-property:opacity,transform;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.drop-up-left-leave-active{transform-origin:bottom right;transition-property:opacity,transform;transition-duration:75ms;transition-timing-function:cubic-bezier(.4,0,.2,1)}.drop-up-right-enter-from,.drop-up-right-leave-to{transform:scale3d(.95,.95,1) translateZ(0);opacity:0}.drop-up-right-enter-active,.drop-up-right-leave-active{backface-visibility:hidden;will-change:opacity,transform;contain:layout style paint}.drop-up-right-enter-active{transform-origin:bottom left;transition-property:opacity,transform;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.drop-up-right-leave-active{transform-origin:bottom left;transition-property:opacity,transform;transition-duration:75ms;transition-timing-function:cubic-bezier(.4,0,.2,1)}.dd-trigger{display:inline-flex;box-sizing:border-box;width:-moz-fit-content;width:fit-content}.dd-trigger.dd-trigger--block{display:flex;width:auto}.dd-content-body{display:flex}.dd-content{position:absolute;top:0;left:0;-webkit-font-smoothing:subpixel-antialiased;display:inline-flex;margin:0;padding:0;max-width:80vw;box-sizing:border-box;background-color:#fff;overflow:hidden;border:1px solid #d0d0d0;box-shadow:0 9px 24px #0000002e,0 3px 6px #00000014}.dd-content.dd-no-border{border:0}.dd-rounded--small{border-radius:.25rem!important}.dd-rounded--medium{border-radius:.5rem!important}.dd-rounded--large{border-radius:.75rem!important}.dd-rounded--pill{border-radius:50rem!important}.dd-rounded--circle{border-radius:50%!important}.dd-content-rounded--small{border-radius:6px!important}.dd-content-rounded--medium{border-radius:12px!important}.dd-content-rounded--large{border-radius:18px!important}.dd-trigger-container{display:inline-block}.dd-trigger-container.dd-disabled .dd-default-trigger,.dd-trigger-container.dd-disabled:hover .dd-default-trigger{border:1px solid #eee;background-color:#eee;cursor:default;color:#aaa}.dd-trigger-container .dd-default-trigger{display:inline-flex;align-items:center;padding:.5rem 1rem;background-color:#fff;border:1px solid #ddd;border-radius:.3rem;font-size:14px;line-height:1.42857143;outline:0!important;color:#666;gap:.5rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}.dd-trigger-container .dd-default-trigger:hover{border:1px solid #aaa;color:#000}.dd-trigger-container .dd-default-trigger .dd-caret-down{transition:transform .2s ease}.dd-trigger-container .dd-default-trigger.dd-opened{box-shadow:3px 2px 6px #0003;border:1px solid #666;color:#000}.dd-trigger-container .dd-default-trigger.dd-opened .dd-caret-down{transform:rotate(180deg)}.dd-trigger-container .dd-default-trigger.dd-opened:hover{border:1px solid #666}.dd-trigger-container .dd-default-trigger.dd-rounded--circle{width:38px;height:38px;padding:0;justify-content:center}.dd-caret-down{display:inline-block;width:0;height:0;border-top:4px solid;border-left:4px solid transparent;border-right:4px solid transparent;vertical-align:middle;content:""}')),document.head.appendChild(t)}}catch(r){console.error("vite-plugin-css-injected-by-js",r)}})();
import { inject as $, ref as w, onUnmounted as ge, onBeforeUnmount as J, onMounted as be, toRef as he, toRefs as me, computed as S, watch as Ce, provide as G, defineComponent as z, createVNode as d, Teleport as we, Transition as ye, withDirectives as De, vShow as Oe } from "vue";
const Q = "click", Te = "hover", Ee = "contextmenu", Ie = 150, Le = 3e3, M = "body", A = "small", H = "medium", ee = "large", Ne = "pill", ne = "circle", Y = [
  A,
  H,
  ee,
  Ne,
  ne
], F = [A, H, ee], te = Symbol("dropdown"), oe = Symbol("internal"), le = Symbol("container"), U = "left", Be = "center", N = "right", K = "up", P = "down";
function xe(e) {
  return window.getComputedStyle(e).display === "none";
}
function Z(e) {
  const n = e.getBoundingClientRect();
  return {
    width: e.offsetWidth,
    height: e.offsetHeight,
    top: n.top,
    left: n.left
  };
}
function q(e) {
  if (!e)
    return {
      width: 0,
      height: 0,
      top: 0,
      left: 0
    };
  if (xe(e)) {
    e.style.visibility = "hidden", e.style.display = "inline-flex";
    const n = Z(e);
    return e.style.visibility = "visible", e.style.display = "none", n;
  }
  return Z(e);
}
function Se(e) {
  return [
    "dd-trigger",
    { "dd-trigger--block": e.block }
  ];
}
function _e(e) {
  return `dd-rounded--${!e || !Y.includes(e) ? H : Y.find((t) => t === e)}`;
}
function Re(e) {
  return `dd-content-rounded--${!e || !F.includes(e) ? A : F.find((t) => t === e)}`;
}
function re(e) {
  return {
    isTriggerByClick: e === Q,
    isTriggerByHover: e === Te,
    isTriggerByContextmenu: e === Ee
  };
}
const ke = () => $(te, {});
function ze(e = 300) {
  let n;
  return (t) => {
    clearTimeout(n), n = setTimeout(t, e);
  };
}
function Ae(e, n, t, l, o, r) {
  const { trigger: a, gap: c } = r, { isTriggerByContextmenu: v } = re(a);
  function s(g, u, f) {
    o.value || (l.value.vertical = P);
    const m = window.scrollY, I = document.documentElement.clientHeight, D = v ? g : u.top + m, p = v ? g : u.top + u.height + c + m, b = D - c - f.height, C = p + f.height > m + I, O = b < m;
    return l.value.vertical === K ? O && !C ? (l.value.vertical = P, p) : b : !O && C ? (l.value.vertical = K, b) : p;
  }
  function h(g, u, f) {
    o.value || (l.value.horizontal = N);
    const m = window.scrollX, I = document.documentElement.clientWidth, D = v ? 0 : u.width, p = v ? g : u.left + m, b = p + D / 2 - f.width / 2, C = p + D - f.width, O = p + f.width > m + I, _ = b + f.width > m + I, B = C < m, R = he(r, "align");
    return R.value === Be ? (l.value.horizontal = _ ? U : N, _ ? C : B ? p : b) : R.value === N ? (l.value.horizontal = B ? N : U, B ? p : C) : (l.value.horizontal = O ? U : N, O ? C : p);
  }
  function y() {
    const g = q(e.value), u = q(n.value);
    return {
      top: s(t.value.y, g, u),
      left: h(t.value.x, g, u)
    };
  }
  return { getDirection: y };
}
function He(e, n) {
  let t = null;
  const l = {
    root: null,
    rootMargin: "0px",
    threshold: [0.5, 0.75, 1]
  }, o = 1e-7, r = (s) => {
    const h = s[0];
    Math.abs(h.intersectionRatio - 1) < o || n?.();
  };
  function a() {
    e.value && (t || (t = new IntersectionObserver(r, l)), t.observe(e.value));
  }
  function c() {
    t && t.unobserve(e.value);
  }
  function v() {
    t && (t.disconnect(), t = null);
  }
  return J(v), {
    startIntersectionObserving: a,
    stopIntersectionObserving: c
  };
}
function Ge(e, n, t) {
  const l = w(!1), o = w(!1);
  let r = null;
  const a = () => {
    if (!o.value) {
      o.value = !0;
      return;
    }
    t?.();
  }, c = () => {
    !e.value || !n.value || l.value || (r || (r = new ResizeObserver(a)), r.observe(e.value), r.observe(n.value), l.value = !0);
  }, v = () => {
    !r || !l.value || (e.value && n.value && (r.unobserve(e.value), r.unobserve(n.value)), l.value = !1, o.value = !1);
  };
  return ge(() => {
    r && (r.disconnect(), r = null, l.value = !1, o.value = !1);
  }), {
    startObserving: c,
    stopObserving: v
  };
}
function L(e, n, t, l) {
  let o = null;
  const r = () => {
    o && (o.removeEventListener(n, t, l), o = null);
  };
  return be(() => {
    o = typeof e == "function" ? e() : e, o?.addEventListener(n, t, l);
  }), J(r), r;
}
function Ue(e, n, t, l) {
  const { emit: o, expose: r } = l, { disabled: a, manual: c, toggle: v } = me(t), s = w(!1), h = w({ x: null, y: null }), y = w({ vertical: P, horizontal: N }), g = w(), u = w({}), f = S(() => t.animated ? `drop-${y.value.vertical}-${y.value.horizontal}` : ""), m = t.appendTo || M, I = t.appendTo !== M, D = ze(Ie), {
    isTriggerByClick: p,
    isTriggerByHover: b,
    isTriggerByContextmenu: C
  } = re(t.trigger), {
    getDirection: O
  } = Ae(e, n, h, y, s, t), {
    startObserving: _,
    stopObserving: B
  } = Ge(e, n, x), {
    startIntersectionObserving: R,
    stopIntersectionObserving: se
  } = He(n, x);
  Ce(s, (i) => {
    o("visible-change", i), i ? (document.body.addEventListener("mousedown", j), _(), R()) : (B(), se(), document.body.removeEventListener("mousedown", j));
  });
  function ue() {
    o("open");
  }
  function ie() {
    o("opened");
  }
  function ae() {
    o("close");
  }
  function ce() {
    o("closed");
  }
  function T() {
    a.value || (x(), b ? D(() => {
      s.value = !0;
    }) : s.value = !0);
  }
  function E() {
    a.value && !s.value || (b ? D(() => {
      s.value = !1;
    }) : s.value = !1);
  }
  const k = () => {
    if (v.value)
      return s.value ? E() : T();
    s.value || T();
  };
  function j(i) {
    if (!s.value || !e.value || !n.value) return;
    const fe = e.value.contains(i.target), pe = n.value.contains(i.target);
    if (fe)
      return C && i.button === 0 ? E() : "";
    pe || E();
  }
  function x() {
    const i = O();
    u.value.top = `${i.top}px`, u.value.left = `${i.left}px`;
  }
  const de = (i) => {
    !p || c.value || (i.stopPropagation(), k());
  }, V = () => b && T(), W = () => b && E(), ve = (i) => {
    !C || c.value || (i.stopPropagation(), i.preventDefault(), h.value.x = i.pageX, h.value.y = i.pageY, T());
  };
  p && L(() => e.value, "click", de), b && (L(() => e.value, "mouseenter", V), L(() => e.value, "mouseleave", W), L(() => n.value, "mouseenter", V), L(() => n.value, "mouseleave", W)), C && L(() => e.value, "contextmenu", ve);
  const X = {
    disabled: S(() => a.value),
    visible: S(() => s.value),
    adjust: x,
    open: T,
    close: E,
    toggleVisible: k
  };
  return G(te, X), G(oe, {
    contentStyles: u,
    setContentClassGetter: (i) => {
      g.value = i;
    }
  }), G(le, {
    appendTo: m,
    defer: I,
    transitionName: f,
    onDropdownOpen: ue,
    onDropdownOpened: ie,
    onDropdownClose: ae,
    onDropdownClosed: ce
  }), r({
    open: T,
    close: E,
    toggleVisible: k,
    adjust: x,
    visible: s
  }), {
    visible: s,
    open: T,
    close: E,
    toggleVisible: k,
    slotData: X,
    getContentClass: g,
    contentStyles: u
  };
}
const Me = /* @__PURE__ */ z({
  name: "DropdownTrigger",
  props: {
    rounded: {
      type: String,
      default: H
    }
  },
  setup(e, {
    slots: n
  }) {
    const t = ke(), l = S(() => ["dd-default-trigger", {
      "dd-opened": t?.visible?.value
    }, _e(e.rounded)]), o = S(() => ({
      "dd-trigger-container": !0,
      "dd-disabled": t?.disabled?.value
    })), r = () => n.default ? n.default() : "Open", a = () => e.rounded === ne ? null : n.append ? n.append() : d("span", {
      class: "dd-caret-down"
    }, null), c = () => d("button", {
      type: "button",
      class: l.value
    }, [d(r, null, null), d(a, null, null)]);
    return () => d("div", {
      class: o.value
    }, [d(c, null, null)]);
  }
}), Pe = /* @__PURE__ */ z({
  name: "DropdownContentContainer",
  setup(e, {
    slots: n
  }) {
    const {
      appendTo: t,
      defer: l,
      transitionName: o,
      onDropdownOpen: r,
      onDropdownOpened: a,
      onDropdownClose: c,
      onDropdownClosed: v
    } = $(le, {}), s = (u, f) => {
      r(), setTimeout(f, 150);
    }, h = (u) => {
      a();
    }, y = (u, f) => {
      c(), setTimeout(f, 75);
    }, g = (u) => {
      v();
    };
    return () => d(we, {
      to: t,
      defer: l
    }, {
      default: () => [d(ye, {
        name: o.value,
        onEnter: s,
        onAfterEnter: h,
        onLeave: y,
        onAfterLeave: g
      }, {
        default: () => n?.default?.()
      })]
    });
  }
}), je = /* @__PURE__ */ z({
  name: "VDropdown",
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    /** Content show up alignment direction */
    align: {
      type: String,
      default: "left"
    },
    /** Toggle display / close dropdown content */
    toggle: {
      type: Boolean,
      default: !0
    },
    /** Manual control the display and hiding of dropdown */
    manual: {
      type: Boolean,
      default: !1
    },
    /**
     * Trigger container display mode
     * - false: inline-flex
     * - true: flex
     */
    block: {
      type: Boolean,
      default: !1
    },
    /**
     * Dropdown trigger method
     * - `click` default
     * - `hover`
     * - `contextmenu`
     */
    trigger: {
      type: String,
      default: Q
    },
    animated: {
      type: Boolean,
      default: !0
    },
    /** The distance(px) between the trigger and the content */
    gap: {
      type: Number,
      default: 5
    },
    /** Dropdown content append target */
    appendTo: {
      type: [String, Object],
      default: M
    }
  },
  emits: ["visible-change", "open", "close", "opened", "closed"],
  setup(e, n) {
    const {
      slots: t
    } = n, l = w(), o = w(), {
      slotData: r,
      visible: a,
      getContentClass: c,
      contentStyles: v
    } = Ue(l, o, e, n), s = () => t.trigger ? t.trigger(r) : d(Me, null, null), h = () => d(Pe, null, {
      default: () => De(d("div", {
        ref: o,
        style: v.value,
        class: c?.value?.()
      }, [t?.default?.(r)]), [[Oe, a.value]])
    });
    return () => d("div", {
      ref: l,
      class: Se(e)
    }, [d(s, null, null), d(h, null, null)]);
  }
}), Ve = /* @__PURE__ */ z({
  name: "DropdownContent",
  // inheritAttrs: false,
  props: {
    border: {
      type: Boolean,
      default: !0
    },
    rounded: {
      type: String,
      default: A
    },
    zIndex: {
      type: Number,
      default: Le
    }
  },
  setup(e, {
    slots: n,
    attrs: t
  }) {
    const {
      setContentClassGetter: l,
      contentStyles: o
    } = $(oe, {});
    return l?.(() => {
      const r = ["dd-content", Re(e.rounded)];
      return e.border || r.push("dd-no-border"), r;
    }), () => (o && (o.value["z-index"] = e.zIndex), d("div", {
      class: "dd-content-body"
    }, [n?.default?.()]));
  }
});
export {
  je as Dropdown,
  Ve as DropdownContent,
  Me as DropdownTrigger,
  ke as useDropdown
};
